// src/pages/Contact.jsx
import React, { useState } from "react";
import Title from "../components/ui/Title";
import PrimaryButton from "../components/ui/PrimaryButton";
import InputField from "../components/ui/InputField";

export default function Contact() {
  const [status, setStatus] = useState("idle");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");

    const formData = {
      name: e.target.name.value,
      email: e.target.email.value,
      message: e.target.message.value,
    };

    try {
      const response = await fetch("https://formspree.io/f/manjenvy", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setStatus("success");
        e.target.reset();
      } else {
        setStatus("error");
      }
    } catch (error) {
      setStatus("error");
    }
  };

  return (
    <div className="p-6 md:p-12 max-w-3xl mx-auto text-text-body">
      <Title>Contact</Title>
      <p className="mb-8 text-lg">
        Dacă simți să lucrăm împreună, să pui o întrebare sau doar să îmi scrii câteva gânduri – acest spațiu e deschis pentru tine.
      </p>

      <form onSubmit={handleSubmit} className="grid gap-4">
        <InputField
          type="text"
          name="name"
          placeholder="Numele tău"
          required
        />
        <InputField
          type="email"
          name="email"
          placeholder="Emailul tău"
          required
        />
        <InputField
          as="textarea"
          name="message"
          placeholder="Mesajul tău"
          rows="5"
          required
        />
        <PrimaryButton type="submit" disabled={status === "sending"}>
          {status === "sending" ? "Se trimite..." : "Trimite"}
        </PrimaryButton>

        {status === "success" && (
          <p className="text-green-600">Mesaj trimis cu succes! Îți mulțumesc. 💌</p>
        )}
        {status === "error" && (
          <p className="text-red-600">Ups! A apărut o eroare. Încearcă din nou.</p>
        )}
      </form>

      <div className="mt-12 text-sm text-gray-700 space-y-2">
        <p>
          📧 Contact direct:{" "}
          <a href="mailto:contact@traiestetidesignul.ro" className="underline">
            contact@traiestetidesignul.ro
          </a>
        </p>
        <p className="flex gap-4 flex-wrap">
          🔗 Social media:
          <a
            href="https://www.facebook.com/traiestetidesignul/"
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
          >
            Facebook
          </a>
          <a
            href="https://www.instagram.com/traiestetidesignul/"
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
          >
            Instagram
          </a>
          <a
            href="https://www.patreon.com/c/HumanDesignJunkFree"
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
          >
            Patreon
          </a>
          <a
            href="https://substack.com/@traitordedesign"
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
          >
            Substack
          </a>
        </p>
      </div>
    </div>
  );
}
